export default __webpack_public_path__ + "static/media/charkhesh.cc69454d.jpg";